import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=7129d97a&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=7129d97a&prod&lang=scss"
import style1 from "./reg.vue?vue&type=style&index=1&id=7129d97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129d97a",
  null
  
)

export default component.exports